import styled, { css } from 'styled-components';
import MenuItem from './MenuItem';
import { getTypographyStyles } from 'breadcrumbs-ui/components/Text';
import { getAccountMenuBorder } from '../../Accounts/shared-styles';
export const StyledMenuPickerTopLink = styled(MenuItem)(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["padding:", " ", " !important;margin:", " !important;", " a:hover{text-decoration:underline !important;}&:not(:only-of-type){border-bottom:", " !important;}a{text-decoration:none;color:", " !important;}"], theme.space['300'], theme.space['600'], theme.space['0'], getTypographyStyles(theme, 'body-100'), getAccountMenuBorder(theme), theme.color['text-interactive-default']);
});